export const getFormViewIsInitializingAsyncOperationId = (formId: string): string => `formview-initialization-${formId}`
